<div class="countdown-timer-container">
  <div
    *ngIf="!isTimerCompleted"
    class="countdown-timer countdown-timer-{{size}} {{classes}} d-inline-block">

    <table class="countdown-timer-table" *ngIf="isTable">
      <tr *ngIf="label">
        <td
          [attr.colspan]="timeLeft.days > 0 ? 4 : 3"
          class="countdown-timer-table__heading">
          {{ label }}
        </td>
      </tr>

      <tr>
        <td *ngIf="timeLeft.days > 0">
          <div class="countdown-timer-table__value">{{ timeLeft.days }}</div>
          <div class="countdown-timer-table__label">
            {{ 'COUNTDOWN.DAYS' | translate }}
          </div>
        </td>

        <td *ngIf="!noDays">
          <div class="countdown-timer-table__value">{{ timeLeft.hours }}</div>
          <div class="countdown-timer-table__label">
            {{ 'COUNTDOWN.HOURS' | translate }}
          </div>
        </td>

        <td>
          <div class="countdown-timer-table__value">{{ timeLeft.minutes }}</div>
          <div class="countdown-timer-table__label">
            {{ 'COUNTDOWN.MINUTES' | translate }}
          </div>
        </td>

        <td>
          <div class="countdown-timer-table__value">{{ timeLeft.seconds }}</div>
          <div class="countdown-timer-table__label">
            {{ 'COUNTDOWN.SECONDS' | translate }}
          </div>
        </td>
      </tr>
    </table>

    <div *ngIf="mode === 'text'" class="d-inline-block countdown-timer-text-{{size}}">
      <div class="countdown-timer-text__value" *ngIf="timeLeft.days > 0">{{ timeLeft.days }}</div>
      <div class="countdown-timer-text__label" *ngIf="timeLeft.days > 0">
        {{ 'COUNTDOWN.D_SHORT' | translate }}
      </div>

      <div class="countdown-timer-text__value">{{ timeLeft.hours }}</div>
      <div class="countdown-timer-text__label">
        {{ 'COUNTDOWN.H_SHORT' | translate }}
      </div>

      <div class="countdown-timer-text__value">{{ timeLeft.minutes }}</div>
      <div class="countdown-timer-text__label">
        {{ 'COUNTDOWN.M_SHORT' | translate }}
      </div>

      <div class="countdown-timer-text__value">{{ timeLeft.seconds }}</div>
      <div class="countdown-timer-text__label">
        {{ 'COUNTDOWN.S_SHORT' | translate }}
      </div>
    </div>

    <div
      *ngIf="mode === 'labelled-text'"
      class="d-flex flex-row d-inline-block countdown-timer-text--labelled countdown-timer-text-{{size}}">

      <div class="d-flex flex-column justify-content-start" *ngIf="timeLeft.days > 0">
        <div class="countdown-timer-text__value">{{ timeLeft.days }}</div>
        <div class="countdown-timer-text__label">
          {{ 'COUNTDOWN.DAYS_LABEL' | translate:{ count: timeLeft.days } }}
        </div>
      </div>
      <div *ngIf="timeLeft.days > 0">&nbsp;|&nbsp;</div>

      <div class="d-flex flex-column justify-content-start">
        <div class="countdown-timer-text__value">{{ timeLeft.hours }}</div>
        <div class="countdown-timer-text__label">
          {{ 'COUNTDOWN.HOURS_LABEL' | translate:{ count: timeLeft.hours } }}
        </div>
      </div>

      <div>&nbsp;|&nbsp;</div>

      <div class="d-flex flex-column">
        <div class="countdown-timer-text__value">{{ timeLeft.minutes }}</div>
        <div class="countdown-timer-text__label">
          {{ 'COUNTDOWN.MINUTES_LABEL' | translate:{ count: timeLeft.minutes } }}
        </div>
      </div>

      <div>&nbsp;|&nbsp;</div>

      <div class="d-flex flex-column">
        <div class="countdown-timer-text__value">{{ timeLeft.seconds }}</div>
        <div class="countdown-timer-text__label">
          {{ 'COUNTDOWN.SECONDS_LABEL' | translate:{ count: timeLeft.seconds } }}
        </div>
      </div>
    </div>
  </div>

  <ng-content *ngIf="isTimerCompleted"></ng-content>
</div>